/* eslint-disable react-hooks/exhaustive-deps */
import { Image, message, Row, } from 'antd';
import { useState, useEffect } from 'react';
import { convertCentsIntoDollar } from '../../../helpers/genericHelper';
import API from '../../../services/API';
import CustomText from '../../CustomText';
import LoaderComponent from '../../Loader';
// { merchantList, loading }
function MerchantsList() {
  const [merchantList, setMechantList] = useState([]);
  const [loading, setLoading] = useState(false)

  const loadMerchants = async () => {
    setLoading(true);
    try {
      let res = await API.getMerchants();
      setMechantList(res.merchantList);
    } catch (e) {
      message.error('Unable to fetch Merchants');

    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadMerchants();
  }, [])

  return (
    <>
      {loading ? (
        <LoaderComponent />
      ) : (
        <>
          <div className="ant-list-box trans table-responsive">
            <table className="width-100">
              <thead>
                <tr>
                  <th>Icon</th>
                  <th>Display Name</th>
                  <th>Filter Query</th>
                  <th>Visible</th>
                  <th>Group</th>
                  <th>Group Enabled</th>
                  <th>Transaction Limit</th>
                </tr>
              </thead>
              <tbody>
                {merchantList && merchantList.length > 0 ? (
                  merchantList.map((data) => {
                    return (
                      <tr>
                        <td>
                          <Image
                            resizeMode={'contain'}
                            src={data.iconUrl}
                            className={'merchant-image'}
                          />
                        </td>
                        <td>
                          <CustomText
                            dataSet={data}
                            property1={'displayName'}
                          />
                        </td>
                        <td>
                          <CustomText
                            dataSet={data}
                            property1={'filterQuery'}
                          />
                        </td>
                        <td>
                          <CustomText dataSet={data} property1={'isVisible'} />
                        </td>
                        <td>
                          {data.merchantGroupName ?? '—'}
                        </td>
                        <td>
                          {data.groupEnabled === null || data.groupEnabled === undefined
                            ? '—'
                            : data.groupEnabled
                            ? 'Yes'
                            : 'No'}
                        </td>
                        <td>
                          <CustomText dataSet={data} property1={'transactionLimit'} formatter={convertCentsIntoDollar} />
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="12" align="center">
                      <Row className="no-data-card">No Data Found</Row>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

        </>
      )}
    </>
  );
}

export default MerchantsList;
